import { Employee, EmployeeCondition, TeamLeaderInfo } from 'models/admin/Employee';
import { CommonRequest, CommonResponse, Method, ServiceName } from 'models/common/RestApi';
import { callApi } from 'utils/ApiUtil';

export const getEmployeeBySearchCondition = async (
  searchItem?: string,
  deptCd?: string,
  deptNm?: string,
  empNm?: string,
  useYn?: string
) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/employee`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      searchItem: searchItem ?? '',
      deptCd: deptCd ?? '',
      deptNm: deptNm ?? '',
      empNm: empNm ?? '',
      useYn: useYn ?? '',
    }),
  };
  const response: CommonResponse<any> = await callApi(request);

  return (response.successOrNot === 'Y' ? response.data : null) as Employee[];
};

export const getEmployeeByCondition = async (condition: EmployeeCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/employee`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...condition,
    }),
  };
  const response: CommonResponse<any> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as Employee[];
};

export const getTeamLeaderIdByDeptCd = async (deptCd: string) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/employee/teamLeaderId`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ deptCd }),
  };
  const response: CommonResponse<TeamLeaderInfo> = await callApi(request);

  return (response.successOrNot === 'Y' ? response.data : null) as TeamLeaderInfo;
};
